import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { parseError } from "apollo";
import { RETAILER_STORE_START_SHIPPING } from "./graphql";

const StartShippingView = ({ orderId, hide }) => {
  const [startShipping, startShippingRes] = useMutation(
    RETAILER_STORE_START_SHIPPING,
    {
      variables: { orderId },
      onCompleted() {
        Alert("success", "The order has been marked as shipping successfully.");
        hide();
      },
      onError(err) {
        Alert("error", parseError(err));
      },
    },
  );

  return (
    <div>
      <div>Are you sure you want to mark this order as shipping?</div>

      <hr />

      <div>
        <Button
          primary
          onClick={startShipping}
          loading={startShippingRes.loading}
        >
          Yes, Mark as Shipping
        </Button>
      </div>
    </div>
  );
};

export default StartShippingView;
